<template>
  <div>
    <div
      v-for="permissionsGroup in groupedPermissions"
      :key="permissionsGroup.name"
    >
      <permissions-group-card
        :permissions-group="permissionsGroup"
        :selected-permissions.sync="selectedPermissionsProxy"
      />
    </div>
  </div>
</template>

<script>
import PermissionsGroupCard from './PermissionsGroupCard.vue'

export default {
  name: 'PermissionsInputs',
  components: { PermissionsGroupCard },
  props: {
    groupedPermissions: { type: Array, default: () => [] },
    selectedPermissions: { type: Array, default: () => [] },
  },
  computed: {
    selectedPermissionsProxy: {
      get() {
        return this.selectedPermissions
      },
      set(value) {
        this.$emit('update:selectedPermissions', value)
      },
    },
  },
}
</script>

<style>

</style>
